import React, { FC, useEffect, useState } from 'react';
import MuiTabs, { TabsProps } from '@mui/material/Tabs';
import MuiTab, { TabProps } from '@mui/material/Tab';
import { styled } from '@mui/material/styles';

import { sizes, colors } from 'src/themes/default';

const TabBlock = styled(MuiTabs)<TabsProps>(({ theme }) => ({
    // borderBottom: '1px solid #e8e8e8',

    '& .MuiTabs-indicator': {
        backgroundColor: colors.primary_O,
    },
}));

const TabItem = styled(MuiTab)<TabProps>(({ theme }) => ({
    fontWeight: sizes.body_W,
    fontSize: sizes.body_FS,
    lineHeight: sizes.body_LH,
    color: colors.text_T2,
    padding: sizes.tab_item_PD,
    textTransform: 'unset',
    borderBottom: '1px solid #e8e8e8',

    '&.Mui-selected': {
        color: colors.primary_O,
    },
}));

export interface TabType {
    value: string;
    label: string;
}
export interface TabsPropsType {
    items: TabType[];
    selected: string;
    onChange: (value: string) => void;
    onClickTab?: (value: string) => void;
    disabled?: boolean;
    disabledItems?: string[];
}

export const getSelectedTabIndex = (items: TabType[], selected?: string): number => {
    if (!selected || !items.length) {
        return 0;
    }
    const index = items.findIndex((item) => item.value === selected);
    return index > -1 ? index : 0;
};

const Tabs: FC<TabsPropsType> = (props) => {
    const [value, setValue] = useState(() => getSelectedTabIndex(props.items, props.selected));

    useEffect(() => {
        const index = getSelectedTabIndex(props.items, props.selected);
        setValue((current) => (current === index ? current : index));
    }, [props.selected, props.items]);

    const handleChange = (e: any, newValue: number) => {
        setValue(newValue);
        props.onChange(props.items[newValue].value);
    };

    return (
        // @ts-ignore
        <TabBlock value={value} onChange={handleChange} variant="scrollable" disabled={props.disabled}>
            {props.items.map((item) => (
                <TabItem
                    label={item.label}
                    key={item.value}
                    disabled={props.disabled || (props.disabledItems && props.disabledItems.includes(item.value))}
                    onClick={() => props.onClickTab?.(item.value)}
                    data-testid={`tab-${item.value}`}
                />
            ))}
        </TabBlock>
    );
};

export default Tabs;
